import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardOthers } from './guards/authOthers.guard';
import { AuthGuardLogin } from './guards/authLogin.guard';

import { Navigation } from 'src/pages/navigation/navigation';
import { LoginPage } from 'src/pages/login/login.page'
import { SplashPage } from 'src/pages/splash/splash.page'
import { CadastroPage } from 'src/pages/cadastro/cadastro.page'
import { NotificacoesPage } from 'src/pages/navigation/configuracoes/notificacoes/notificacoes.page'
import { AlterarSenhaPage } from 'src/pages/navigation/configuracoes/alterar-senha/alterar-senha.page'
import { GraficoPage } from 'src/pages/grafico-ativo/grafico.page';
import { ContratacaoPage } from 'src/pages/contratacao/contratacao.page';
import { AvaliacaoPage } from 'src/pages/avaliacao/avaliacao.page'
import { EsqueciMinhaSenhaPage } from 'src/pages/esqueci-minha-senha/esqueci-minha-senha.page';
import { FormularioTrader } from 'src/pages/formulario-trader/formulario-trader.page';
import { Resultado } from 'src/pages/formulario-trader/resultado/resultado.page';
import { PlanoIosPage } from 'src/pages/plano-ios/PlanoIosPage';
import { CarteiraRecomendadaSimuladorPage } from 'src/pages/CarteiraRecomendada/CarteiraRecomendadaDetalhe/CarteiraRecomendadaSimulador/CarteiraRecomendadaSimuladorPage';
import { CarteiraRecomendadaAlteracaoPage } from 'src/pages/CarteiraRecomendada/CarteiraRecomendadaDetalhe/CarteiraRecomendadaAlteracao/CarteiraRecomendadaAlteracaoPage';
import { OnboardingPage } from 'src/pages/onboarding/onboarding.page';
import { ListaRecomendacoesPage } from 'src/pages/navigation/recomendacoes/lista-recomendacoes/lista-recomendacoes.page';
import { WebViewPage } from 'src/pages/webview/webview.page';
import { ConfiguracoesPage } from 'src/pages/navigation/configuracoes/configuracoes.page';
import { RecomendacoesOpcoesPage } from 'src/pages/recomendacoes-opcoes/recomendacoes-opcoes.page';
import { RecomendacoesOpcoesBoletaPage } from './components/options-strategy/options-billet/options-billet.page';
import { ClientProspectPage } from 'src/pages/client-prospect/client-prospect.page';
import { ErrorGenericPage } from 'src/pages/errorGeneric/error-generic.page';

const tabRoutes: Routes = [
  {
    path: 'navigation',
    component: Navigation,
    canActivate: [AuthGuardOthers],
    children: [
      {
        path: 'prisma',
        children: [
          {
            path: '',
            loadChildren: () => import('../pages/navigation/prisma/prisma.module').then(m => m.PrismaPageModule)
          }
        ]
      },
      {
        path: 'home',
        children: [
          {
            path: '',
            loadChildren: () => import('../pages/navigation/home/home.module').then(m => m.HomePageModule)
          },
          // {
          //   path: 'blog',
          //   loadChildren: () => import('../pages/navigation/blog/blog.module').then(m => m.BlogPageModule)
          // },
          {
            path: 'noticias',
            loadChildren: () => import('../pages/noticias/noticias.module').then(m => m.NoticiasPageModule)
          }
        ]
      },
      {
        path: 'recomendacoes',
        children: [
          {
            path: '',
            redirectTo: 'default',
            pathMatch: 'full'
          },
          {
            path: ':tipoAtivo',
            loadChildren: () => import('../pages/navigation/recomendacoes/lista-recomendacoes/lista-recomendacoes.module').then(m => m.ListaRecomendacoesPageModule)
          },
          // {
          //   path: ':tipoAtivo',
          //   loadChildren: () => import('../pages/navigation/recomendacoes/lista-recomendacoes/lista-recomendacoes.module').then(m => m.ListaRecomendacoesPageModule)
          // }
        ]
      },
      {
        path: 'recomendacoes-opcoes',
        children: [
          {
            path: '',
            redirectTo: 'default',
            pathMatch: 'full'
          },
          {
            path: ':tipoAtivo',
            loadChildren: () => import('../pages/recomendacoes-opcoes/recomendacoes-opcoes.module').then(m => m.RecomendacoesOpcoesPageModule)
          }
        ]
      },
      {
        path: 'analise-ativos',
        children: [
          {
            path: '',
            redirectTo: 'default',
            pathMatch: 'full'
          },
          {
            path: ':tipoAtivo',
            loadChildren: () => import('../pages/navigation/analise-ativos/analise-ativos.module').then(m => m.AnaliseAtivosPageModule)
          }
        ]
      },
      {
        path: 'carteira-recomendada',
        children: [
          {
            path: '',
            loadChildren: () => import('../pages/CarteiraRecomendada/CarteiraRecomendadaPage.module').then(m => m.CarteiraRecomendadaPageModule)
          },
          {
            path: ':idCarteira',
            loadChildren: () => import('../pages/CarteiraRecomendada/CarteiraRecomendadaDetalhe/CarteiraRecomendadaDetalhePage.module').then(m => m.CarteiraRecomendadaDetalhePageModule)
          }
        ]
      },
      {
        path: '',
        redirectTo: '/navigation/home',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'login',
    component: LoginPage,
    canActivate: [AuthGuardLogin],
  },
  {
    path: 'onboarding',
    component: OnboardingPage,
    canActivate: [AuthGuardLogin],
  },
  {
    path: 'esqueci-minha-senha',
    component: EsqueciMinhaSenhaPage,
    canActivate: [AuthGuardLogin],
  },
  {
    path: 'splash',
    component: SplashPage,
    canActivate: [AuthGuardOthers],
  },
  {
    path: 'cadastro',
    component: CadastroPage,
    canActivate: [AuthGuardLogin],
  },
  {
    path: 'navigation/configuracoes/notificacoes',
    component: NotificacoesPage,
    canActivate: [AuthGuardOthers],
  },
  {
    path: 'navigation/configuracoes/trocar-senha',
    component: AlterarSenhaPage,
    canActivate: [AuthGuardOthers],
  },
  {
    path: 'navigation/configuracoes',
    component: ConfiguracoesPage,
    canActivate: [AuthGuardOthers],
  },
  {
    path: 'navigation/recomendacoes/ativo/:tipoAtivo/:idAtivo',
    component: ListaRecomendacoesPage,
    canActivate: [AuthGuardOthers],
  },
  {
    path: 'navigation/recomendacoes/ativo/:tipoAtivo/:data/grafico',
    component: GraficoPage,
    canActivate: [AuthGuardOthers],
  },
  {
    path: 'navigation/recomendacoes-opcoes/ativo/:tipoAtivo/:idAtivo',
    component: RecomendacoesOpcoesPage,
    canActivate: [AuthGuardOthers],
  },
  {
    path: 'navigation/recomendacoes-opcoes/ativo/boleta',
    component: RecomendacoesOpcoesBoletaPage,
    canActivate: [AuthGuardOthers],
  },
  {
    path: 'contratacao',
    component: ContratacaoPage,
    canActivate: [AuthGuardOthers],
  },
  {
    path: 'avaliacao',
    component: AvaliacaoPage,
    canActivate: [AuthGuardOthers],
  },
  {
    path: 'formulario-trader',
    component: FormularioTrader,
    canActivate: [AuthGuardOthers],
  },
  {
    path: 'formulario-trader-resultado',
    component: Resultado,
    canActivate: [AuthGuardOthers],
  },
  {
    path: 'plano-ios',
    component: PlanoIosPage,
    canActivate: [AuthGuardOthers],
  },
  {
    path: 'carteira-recomendada-simulador',
    component: CarteiraRecomendadaSimuladorPage,
    canActivate: [AuthGuardOthers],
  },
  {
    path: 'carteira-recomendada-alteracoes',
    component: CarteiraRecomendadaAlteracaoPage,
    canActivate: [AuthGuardOthers],
  },
  {
    path: 'webview/:data',
    component: WebViewPage,
    canActivate: [AuthGuardOthers],
  },
  {
    path: 'client-prospect',
    component: ClientProspectPage,
    canActivate: [AuthGuardOthers],
  },
  {
    path: 'client-prospect/:token',
    component: ClientProspectPage
  },
  {
    path: 'error-generic',
    component: ErrorGenericPage
  },
  // {
  //   path: '',
  //   redirectTo: 'onboarding',
  //   pathMatch: 'full'
  // },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'onboarding'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(tabRoutes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
